import { render, staticRenderFns } from "./AccessGroupDialog.vue?vue&type=template&id=78812a92&scoped=true"
import script from "./AccessGroupDialog.vue?vue&type=script&lang=js"
export * from "./AccessGroupDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78812a92",
  null
  
)

export default component.exports